import { useState, useCallback, useEffect } from 'react';
import Modal from 'react-modal';
import './styles.scss';
import { updateUserSchedulingNotificationSettings } from '../../../../../services/user';
import { useAuth } from '../../../../../container/authContext';
import { isResponseOk } from '../../../../../utility/isResponseOk';

const NotificationSettingsModal = ({ closeModal }) => {
  const { user, setUser, updateUser } = useAuth();
  const [formData, setFormData] = useState({
    scheduling_notifications_enabled: user.scheduling_notifications_enabled,
  });

  const updateSchedulingNotification = useCallback(async () => {
    try {
      const payload = {
        scheduling_notifications_enabled: formData.scheduling_notifications_enabled,
      };

      const response = await updateUserSchedulingNotificationSettings(payload);
      if (response && isResponseOk(response)) {
        updateUser();
      }
    } catch (e) {
      console.error(e);
    }
  }, [user, updateUser, formData]);

  const handleConfirm = () => {
    updateSchedulingNotification();
    closeModal();
  };

  return (
    <Modal
      className="modal-alert scheduling-notification-settings-modal"
      isOpen
      onRequestClose={closeModal}
      contentLabel="Scheduling Notification Settings modal"
      ariaHideApp={false}
    >
      <h2 className="modal-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="5" y="5" width="38" height="38" rx="19" fill="#F4EBFF" />
            <rect x="5" y="5" width="38" height="38" rx="19" stroke="#F9F5FF" strokeWidth="10" />
            <g clipPath="url(#clip0_14655_86745)">
              <path
                d="M23.9998 25.9974C25.1044 25.9974 25.9998 25.102 25.9998 23.9974C25.9998 22.8928 25.1044 21.9974 23.9998 21.9974C22.8953 21.9974 21.9998 22.8928 21.9998 23.9974C21.9998 25.102 22.8953 25.9974 23.9998 25.9974Z"
                stroke="#7F56D9"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M28.9332 25.9974C28.8444 26.1985 28.818 26.4215 28.8572 26.6378C28.8964 26.8541 28.9995 27.0536 29.1532 27.2107L29.1932 27.2507C29.3171 27.3746 29.4155 27.5216 29.4826 27.6835C29.5497 27.8453 29.5842 28.0188 29.5842 28.1941C29.5842 28.3693 29.5497 28.5428 29.4826 28.7046C29.4155 28.8665 29.3171 29.0136 29.1932 29.1374C29.0693 29.2614 28.9223 29.3597 28.7604 29.4268C28.5986 29.4939 28.4251 29.5284 28.2498 29.5284C28.0746 29.5284 27.9011 29.4939 27.7393 29.4268C27.5774 29.3597 27.4303 29.2614 27.3065 29.1374L27.2665 29.0974C27.1094 28.9437 26.9098 28.8406 26.6936 28.8014C26.4773 28.7622 26.2542 28.7887 26.0532 28.8774C25.856 28.9619 25.6878 29.1022 25.5694 29.2811C25.4509 29.4599 25.3874 29.6695 25.3865 29.8841V29.9974C25.3865 30.351 25.246 30.6902 24.996 30.9402C24.7459 31.1903 24.4068 31.3307 24.0532 31.3307C23.6995 31.3307 23.3604 31.1903 23.1104 30.9402C22.8603 30.6902 22.7198 30.351 22.7198 29.9974V29.9374C22.7147 29.7167 22.6432 29.5027 22.5148 29.3232C22.3864 29.1437 22.207 29.0069 21.9998 28.9307C21.7988 28.842 21.5757 28.8155 21.3594 28.8547C21.1432 28.8939 20.9436 28.997 20.7865 29.1507L20.7465 29.1907C20.6227 29.3147 20.4756 29.413 20.3138 29.4801C20.1519 29.5472 19.9784 29.5818 19.8032 29.5818C19.6279 29.5818 19.4544 29.5472 19.2926 29.4801C19.1307 29.413 18.9837 29.3147 18.8598 29.1907C18.7359 29.0669 18.6375 28.9198 18.5704 28.758C18.5033 28.5961 18.4688 28.4226 18.4688 28.2474C18.4688 28.0722 18.5033 27.8987 18.5704 27.7368C18.6375 27.5749 18.7359 27.4279 18.8598 27.3041L18.8998 27.2641C19.0535 27.1069 19.1566 26.9074 19.1958 26.6911C19.2351 26.4749 19.2086 26.2518 19.1198 26.0507C19.0353 25.8535 18.895 25.6854 18.7161 25.5669C18.5373 25.4485 18.3277 25.3849 18.1132 25.3841H17.9998C17.6462 25.3841 17.3071 25.2436 17.057 24.9935C16.807 24.7435 16.6665 24.4044 16.6665 24.0507C16.6665 23.6971 16.807 23.358 17.057 23.1079C17.3071 22.8579 17.6462 22.7174 17.9998 22.7174H18.0598C18.2805 22.7122 18.4945 22.6408 18.674 22.5124C18.8536 22.384 18.9903 22.2046 19.0665 21.9974C19.1552 21.7963 19.1817 21.5733 19.1425 21.357C19.1033 21.1407 19.0002 20.9412 18.8465 20.7841L18.8065 20.7441C18.6825 20.6202 18.5842 20.4732 18.5171 20.3113C18.45 20.1495 18.4155 19.9759 18.4155 19.8007C18.4155 19.6255 18.45 19.452 18.5171 19.2901C18.5842 19.1283 18.6825 18.9812 18.8065 18.8574C18.9303 18.7334 19.0774 18.6351 19.2393 18.568C19.4011 18.5009 19.5746 18.4663 19.7498 18.4663C19.9251 18.4663 20.0986 18.5009 20.2604 18.568C20.4223 18.6351 20.5693 18.7334 20.6932 18.8574L20.7332 18.8974C20.8903 19.0511 21.0898 19.1542 21.3061 19.1934C21.5224 19.2326 21.7454 19.2061 21.9465 19.1174H21.9998C22.197 19.0329 22.3652 18.8926 22.4836 18.7137C22.6021 18.5348 22.6656 18.3253 22.6665 18.1107V17.9974C22.6665 17.6438 22.807 17.3046 23.057 17.0546C23.3071 16.8045 23.6462 16.6641 23.9998 16.6641C24.3535 16.6641 24.6926 16.8045 24.9426 17.0546C25.1927 17.3046 25.3332 17.6438 25.3332 17.9974V18.0574C25.334 18.2719 25.3976 18.4815 25.516 18.6604C25.6345 18.8392 25.8027 18.9796 25.9998 19.0641C26.2009 19.1528 26.424 19.1793 26.6402 19.1401C26.8565 19.1009 27.0561 18.9978 27.2132 18.8441L27.2532 18.8041C27.377 18.6801 27.5241 18.5817 27.6859 18.5146C27.8478 18.4476 28.0213 18.413 28.1965 18.413C28.3717 18.413 28.5452 18.4476 28.7071 18.5146C28.869 18.5817 29.016 18.6801 29.1398 18.8041C29.2638 18.9279 29.3622 19.0749 29.4293 19.2368C29.4963 19.3987 29.5309 19.5722 29.5309 19.7474C29.5309 19.9226 29.4963 20.0961 29.4293 20.258C29.3622 20.4198 29.2638 20.5669 29.1398 20.6907L29.0998 20.7307C28.9461 20.8878 28.843 21.0874 28.8038 21.3037C28.7646 21.5199 28.7911 21.743 28.8798 21.9441V21.9974C28.9643 22.1946 29.1047 22.3627 29.2835 22.4812C29.4624 22.5996 29.672 22.6632 29.8865 22.6641H29.9998C30.3535 22.6641 30.6926 22.8045 30.9426 23.0546C31.1927 23.3046 31.3332 23.6438 31.3332 23.9974C31.3332 24.351 31.1927 24.6902 30.9426 24.9402C30.6926 25.1903 30.3535 25.3307 29.9998 25.3307H29.9398C29.7253 25.3316 29.5157 25.3952 29.3369 25.5136C29.158 25.6321 29.0177 25.8002 28.9332 25.9974Z"
                stroke="#7F56D9"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_14655_86745">
                <rect width="16" height="16" fill="white" transform="translate(16 16)" />
              </clipPath>
            </defs>
          </svg>

          <span className="modal-header-title">Notification Settings</span>
        </div>
        <button className="btn btn-icon" onClick={closeModal}>
          <i className="icon-icon-x"></i>
        </button>
      </h2>

      <div>
        <div className="scheduling-notification-settings-form">
          <div className="form-item">
            <div className="form-control-checkbox">
              <input
                name="scheduling_notifications_enabled"
                type="checkbox"
                checked={formData.scheduling_notifications_enabled}
                onChange={() => setFormData({ ...formData, scheduling_notifications_enabled: !formData.scheduling_notifications_enabled })}
              />
              <span>Enable Notifications for Scheduling Manager</span>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <button className="btn btn-outline" onClick={closeModal}>
          Cancel
        </button>
        <button
          className="btn"
          onClick={(e) => {
            e.stopPropagation();
            handleConfirm();
          }}
        >
          Confirm
        </button>
      </div>
    </Modal>
  );
};

export default NotificationSettingsModal;
